import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_chat_warning.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_arrow_down.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_arrow_up.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-77de5108")

_pushScopeId("data-v-77de5108")
const _hoisted_1 = { class: "bg-white w-full rounded-xl p-8 mx-4 my-4" }
const _hoisted_2 = {
  key: 0,
  class: "flex gap-x-6 text-16px border-b border-gray-lp-400 pb-1"
}
const _hoisted_3 = {
  key: 1,
  class: "flex gap-x-6 text-16px border-b border-gray-lp-400"
}
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "py-2.5 flex items-center gap-2" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "flex flex-row justify-between border-b py-3 px-4 font-medium text-14px" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "font-montserrat text-gray-lp-300" }, " Filter ", -1)
const _hoisted_9 = { class: "flex flex-col gap-y-4 p-4 border-b text-gray-lp-300" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "text-sm font-medium" }, " Kategori ", -1)
const _hoisted_11 = { class: "pl-2.5 py-2" }
const _hoisted_12 = { class: "break-words" }
const _hoisted_13 = { class: "flex flex-col gap-y-4 p-4 border-b text-gray-lp-300" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "text-sm font-medium" }, " Status ", -1)
const _hoisted_15 = { class: "flex flex-col gap-y-4 p-4 text-gray-lp-300" }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "text-sm font-medium" }, " Prioritas ", -1)
const _hoisted_17 = { class: "flex z-50 sticky bottom-0 pb-2 border-t border-gray-lp-400 bg-white" }
const _hoisted_18 = { class: "w-6/12 pl-2 pr-1 mt-2" }
const _hoisted_19 = { class: "w-6/12 pr-2 pl-1 mt-2" }
const _hoisted_20 = { class: "flex flex-row gap-x-1" }
const _hoisted_21 = { class: "text-xs" }
const _hoisted_22 = {
  key: 0,
  src: _imports_1,
  width: "18",
  height: "18"
}
const _hoisted_23 = {
  key: 1,
  src: _imports_2,
  width: "18",
  height: "18"
}
const _hoisted_24 = {
  class: "absolute z-50 mt-4",
  style: {"border-bottom":"85px solid transparent"}
}
const _hoisted_25 = { class: "bg-white border border-gray-lp-2100 rounded-md px-4" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", null, " Terlama ", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  width: "18",
  height: "18"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("span", null, " Terbaru ", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  width: "18",
  height: "18"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_custom_dropdown = _resolveComponent("custom-dropdown")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_advanced_filter = _resolveComponent("advanced-filter")!
  const _component_Search = _resolveComponent("Search")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode(_component_Skeleton, {
              height: "1.5rem",
              width: "128px"
            }),
            _createVNode(_component_Skeleton, {
              height: "1.5rem",
              width: "128px"
            }),
            _createVNode(_component_Skeleton, {
              height: "1.5rem",
              width: "128px"
            })
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createBlock("button", {
                key: tab.name,
                onClick: ($event: any) => (_ctx.changeTabs(tab.name)),
                class: 
            `pb-4 font-medium flex gap-1 items-center hover:text-red-lp-100 focus:outline-none ${
              _ctx.isTabActive(tab.name)
                ? 'text-red-lp-100 font-semibold border-b-2 border-red-lp-100'
                : 'text-gray-lp-600'
            }`
          ,
                id: tab.id
              }, [
                _createTextVNode(_toDisplayString(tab.title) + " ", 1),
                (tab.isNotif)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _imports_0,
                      class: "w-3.5",
                      id: tab.idNotif
                    }, null, 8, ["id"]))
                  : _createCommentVNode("", true)
              ], 10, ["onClick", "id"]))
            }), 128))
          ]))
    ]),
    _createVNode("section", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterButtons, (item, key) => {
          return (_openBlock(), _createBlock(_Fragment, { key: key }, [
            (_ctx.loading && item.showButton)
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 0,
                  height: "1.5rem",
                  width: "128px"
                }))
              : (item.showButton)
                ? (_openBlock(), _createBlock("div", {
                    key: 1,
                    class: [
              'rounded-md leading-tight px-3 font-semibold py-2.5 text-xs border',
              _ctx.filter[item.flag]
                ? 'text-red-lp-100 bg-red-lp-50 border-pink-lp-300'
                : 'text-gray-lp-300 bg-white',
            ],
                    style: {"cursor":"pointer"},
                    onClick: ($event: any) => (_ctx.filterTicket(item.type))
                  }, [
                    _createVNode("span", null, _toDisplayString(`${item.label} (${_ctx.filter[item.countKey]})`), 1)
                  ], 10, ["onClick"]))
                : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _createVNode(_component_advanced_filter, {
          ref: "advancedFilter",
          isButtonApply: "",
          showChevron: "",
          showCountFilter: "",
          isSeparateContent: "",
          widthSeparateContent: "330px",
          customMaxHeightSeparateContent: "60vh",
          customWidthSeparateContent: "w-110px",
          addSumFilter: _ctx.filterLength,
          customTitleFilter: 
            _ctx.filterLength ? 'text-red-lp-100 font-semibold' : ''
          ,
          customFilterButton: 
            _ctx.filterLength
              ? 'bg-red-lp-50 border border-pink-lp-300'
              : 'bg-white border border-gray-lp-400'
          
        }, {
          "custom-filter": _withId(() => [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode("p", {
                  class: `${_ctx.disableFilterButton ? 'text-gray-lp-800' : 'text-red-lp-100 cursor-pointer'}`,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.disableFilterButton ? null : _ctx.resetFilter()))
                }, " Reset ", 2)
              ]),
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_custom_dropdown, { placeholder: "Pilih kategori" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_11, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listCategory, (category, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: "p-field-checkbox mt-1 flex items-center gap-2.5"
                        }, [
                          _createVNode(_component_Checkbox, {
                            name: `category-${category.value}`,
                            id: category.value,
                            value: category.value,
                            modelValue: _ctx.filter.category,
                            "onUpdate:modelValue": ($event: any) => (_ctx.filter.category = $event)
                          }, null, 8, ["name", "id", "value", "modelValue", "onUpdate:modelValue"]),
                          _createVNode("div", _hoisted_12, [
                            _createVNode("label", {
                              for: index,
                              class: "text-sm"
                            }, _toDisplayString(category.name), 9, ["for"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusOptions, (status, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    class: "p-field-checkbox"
                  }, [
                    _createVNode(_component_Checkbox, {
                      modelValue: _ctx.filter.status,
                      "onUpdate:modelValue": ($event: any) => (_ctx.filter.status = $event),
                      name: `status-${status.value}`,
                      id: status.value,
                      value: status.value
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "id", "value"]),
                    _createVNode("label", {
                      for: index,
                      class: "ml-2.5 text-sm"
                    }, _toDisplayString(status.name), 9, ["for"])
                  ]))
                }), 128))
              ]),
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.priorityOptions, (prioritas, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    class: "p-field-checkbox"
                  }, [
                    _createVNode(_component_Checkbox, {
                      modelValue: _ctx.filter.prioritas,
                      "onUpdate:modelValue": ($event: any) => (_ctx.filter.prioritas = $event),
                      name: `prioritas-${prioritas.value}`,
                      id: prioritas.value,
                      value: prioritas.value
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "id", "value"]),
                    _createVNode("label", {
                      for: index,
                      class: "ml-2.5 text-sm"
                    }, _toDisplayString(prioritas.name), 9, ["for"])
                  ]))
                }), 128))
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _createVNode(_component_LpButton, {
                    color: "white",
                    textColor: "red-lp-100",
                    title: "Reset",
                    outline: "",
                    isWidthFull: "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetFilter())),
                    disabled: _ctx.disableFilterButton
                  }, null, 8, ["disabled"])
                ]),
                _createVNode("div", _hoisted_19, [
                  _createVNode(_component_LpButton, {
                    color: "red-lp-100",
                    textColor: "white",
                    title: "Terapkan",
                    isWidthFull: "",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterSelect())),
                    disabled: _ctx.disableFilterButton
                  }, null, 8, ["disabled"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["addSumFilter", "customTitleFilter", "customFilterButton"]),
        _withDirectives(_createVNode("div", null, [
          _createVNode("div", {
            class: "rounded-md leading-tight px-3 text-red-lp-100 font-semibold bg-red-lp-50 border border-pink-lp-300 py-2.5",
            style: {"cursor":"pointer"},
            onClick: _cache[4] || (_cache[4] = 
              () => {
                _ctx.openFilterSort = !_ctx.openFilterSort;
              }
            )
          }, [
            _createVNode("div", _hoisted_20, [
              _createVNode("span", _hoisted_21, _toDisplayString(_ctx.filterSortSelected), 1),
              (_ctx.filter.sort === 'asc')
                ? (_openBlock(), _createBlock("img", _hoisted_22))
                : (_ctx.filter.sort === 'desc')
                  ? (_openBlock(), _createBlock("img", _hoisted_23))
                  : _createCommentVNode("", true)
            ])
          ]),
          _withDirectives(_createVNode("div", _hoisted_24, [
            _createVNode("div", _hoisted_25, [
              _createVNode("div", {
                class: "flex items-center gap-1 pb-2 text-sm text-gray-lp-300 pt-4 px-4 cursor-pointer",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filterSort('asc')))
              }, [
                _hoisted_26,
                _hoisted_27
              ]),
              _createVNode("div", {
                class: "flex items-center gap-1 pt-2 text-sm text-gray-lp-300 pb-4 px-4 cursor-pointer",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterSort('desc')))
              }, [
                _hoisted_28,
                _hoisted_29
              ])
            ])
          ], 512), [
            [_vShow, _ctx.openFilterSort]
          ])
        ], 512), [
          [_directive_click_outside, 
            () => {
              _ctx.openFilterSort = false;
            }
          ]
        ])
      ]),
      _createVNode("div", null, [
        _createVNode(_component_Search, {
          onInput: _ctx.onSearch,
          onClear: _ctx.clearSearch,
          value: _ctx.filter.search,
          class: "w-300px mb-1 rounded-md",
          placeholder: "Cari no. kendala/STT/shipment",
          isIconLeft: "",
          isIconClearRight: ""
        }, null, 8, ["onInput", "onClear", "value"])
      ])
    ]),
    _createVNode(_component_TableV2, {
      columns: _ctx.columns,
      isHeaderEmptyActive: _ctx.firstRowHeaderColumns,
      loading: _ctx.loading,
      data: _ctx.dataListTicket.data,
      customClassPagination: "absolute bottom-0 left-0 right-0 flex items-center px-4 h-8 bg-white mb-4",
      paginationStyle: "v3",
      borderBottom: false,
      borderTop: false,
      bgHeader: "bg-white border-b border-t",
      iconEmpty: _ctx.iconEmpty,
      emptyHeaderMessage: _ctx.emptyHeaderMessage,
      emptyMessage: _ctx.emptyMessage,
      isEmpty: !_ctx.dataListTicket.data.length,
      rowColor: "bg-gray-lp-1000",
      isSpaceTop: false,
      isSpaceBottom: "",
      pagination: _ctx.dataListTicket.pagination,
      "onUpdate:pagination": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataListTicket.pagination = $event)),
      onRequest: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getListTicket())),
      paginationV3PaddingVertical: ""
    }, null, 8, ["columns", "isHeaderEmptyActive", "loading", "data", "iconEmpty", "emptyHeaderMessage", "emptyMessage", "isEmpty", "pagination"])
  ]))
})